
import React from 'react';
import './../../../../../../styles/info-accesory.css';

import { RIM_OR_WELLS, ACCESORIES } from '../../../../../../constants/app/files';

const InfoAccesory = ({accessories = []}) => {

    let accessoriesType = Object.keys(ACCESORIES);
    let rimwhelsType =  Object.keys(RIM_OR_WELLS);
    let dataAccessories = accessories.filter((accessory) =>  accessoriesType.includes(accessory.accessoryCode));
    let dataRimsWhels = accessories.filter((accessory) =>  rimwhelsType.includes(accessory.accessoryCode));
    
    const accesoriesContent = dataAccessories.map((accs, index) => {
        return (
                <tr key={index}>
                    <td className="text-md desc">{ACCESORIES[accs.accessoryCode]}</td>
                    <td className="text-md desc">{accs.accessoryBrandModel}</td>
                    <td className="text-md desc">{accs.quantity}</td>
                </tr>
            )
    });

    const rimsAndWellsContent = dataRimsWhels.map((element, index) => {
        return (
            <tr key={index}>
                <td className="text-md desc">{RIM_OR_WELLS[element.accessoryCode]}</td>
                <td className="text-md desc">{element.accessoryBrandModel}</td>
                <td className="text-md desc">{element.quantity}</td>
            </tr>
        )
    });
    return (
        <div className="main-accesory">
            <table>
                <tbody className="main-accs">
                    {dataAccessories.length ? <tr className="gray-background h3 mb10">
                        <td>MUSICALES</td>
                        <td>Marca/Modelo</td>
                        <td>Cant.</td>
                    </tr> : null}

                    {accesoriesContent.length ? accesoriesContent : null}
                </tbody>
                <tbody>{dataRimsWhels.length ? <tr className="gray-background h3 mb10">
                        <td>LLANTAS Y AROS</td>
                        <td>Marca</td>
                        <td>Cant.</td>
                    </tr> : null}
                    {rimsAndWellsContent.length ? rimsAndWellsContent : null}
                </tbody>
            </table>
        </div>
    );
}

export default InfoAccesory;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/accessories/info-accessory.js